import styled, { css } from 'styled-components';
import { Spinner, SPINNER_SIZES } from '../spinner/Spinner';

export type RouteLoadingProps = {
  overlay?: boolean;
};

const LoadingWrapper = styled.div<{ $overlay: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  inset: 0;
  min-height: 0;
  width: auto;

  ${({ $overlay, theme }) =>
    $overlay &&
    css`
      z-index: 10;
      background: linear-gradient(
        to bottom,
        transparent 0,
        transparent var(--page-header-height, 0px),
        ${theme.palette.neutral.surface} var(--page-header-height, 0px),
        ${theme.palette.neutral.surface} 100%
      );
    `}
`;

export const RouteLoading = ({ overlay = false }: RouteLoadingProps) => {
  return (
    <LoadingWrapper $overlay={overlay} role='status' aria-live='polite'>
      <div aria-hidden='true'>
        <Spinner size={SPINNER_SIZES.page} inLine />
      </div>
      {/* TODO: Add a top-level `loading_aria_label` translation key. */}
    </LoadingWrapper>
  );
};
